import Modal from '@components/Modal';
import config from '@config/index';
import { useVendor } from '@context/VendorContext';
import { FlexView, Link } from '@goodfynd/ui';
import { Button } from '@goodfynd/ui';
import { Text } from '@goodfynd/ui';
import { Checkbox, FormControlLabel } from '@mui/material';
import { dateUtil } from '@utils/index';

import type { OneClickSchedulePreviewProps } from './types';

import classes from './OneClickSchedulePreview.module.css';

export function OneClickSchedulePreview({
  busy,
  data,
  onChangeStep,
  onClose,
  onConfirm,
  open,
  setPickupCapacity,
}: OneClickSchedulePreviewProps) {
  const { vendor } = useVendor();
  return (
    <Modal
      close={onClose}
      containerCss={{ width: 480 }}
      header={<Text as="modalHeader">Add Truck to Goodfynd Map</Text>}
      open={open}
      footer={
        <div className={classes.footer}>
          <Button busy={busy} disabled={busy} onClick={onConfirm}>
            Add to Public Map
          </Button>
        </div>
      }
    >
      <div className={classes.content}>
        <div>
          <div>
            <Text as="body2">Location</Text>
          </div>
          <div>
            <Text>{data.location.address}</Text>
            <Text as="body2">
              {[
                data.location.county,
                // , data.location.city, data.location.state
              ]
                .filter(Boolean)
                .join(', ')}
            </Text>
          </div>
          <Link
            as="caption"
            className="cursor-pointer"
            display="underline"
            onClick={() => onChangeStep(2)}
          >
            Change
          </Link>
        </div>

        <FlexView gap={32}>
          <div>
            <div>
              <Text as="body2">Date</Text>
            </div>
            <div>
              <Text>
                {dateUtil.format(
                  data.startTime,
                  config.dateFormats.monthDayYearLong
                )}
              </Text>
            </div>
            <Link
              as="caption"
              className="cursor-pointer"
              display="underline"
              onClick={() => onChangeStep(1)}
            >
              Change
            </Link>
          </div>

          <div>
            <div>
              <Text as="body2">Time</Text>
            </div>
            <div>
              <Text>
                {dateUtil.format(data.startTime, config.dateFormats.timeSpace)}
                &nbsp; -&nbsp;
                {dateUtil.format(data.endTime, config.dateFormats.timeSpace)}
              </Text>
            </div>
            <Link
              as="caption"
              className="cursor-pointer"
              display="underline"
              onClick={() => onChangeStep(3)}
            >
              Change
            </Link>
          </div>
        </FlexView>

        {vendor.pickupCapacity > 0 && (
          <FlexView direction="column" gap={0}>
            <FormControlLabel
              label="Accept Online Orders"
              value={data.pickupCapacity === vendor.pickupCapacity}
              control={
                <Checkbox
                  checked={data.pickupCapacity === vendor.pickupCapacity}
                  onChange={(event) => {
                    setPickupCapacity(
                      event.target.checked ? vendor.pickupCapacity : 0
                    );
                  }}
                />
              }
            />

            <Link
              as="caption"
              className="cursor-pointer"
              display="underline"
              onClick={() => onChangeStep(4)}
              style={{ marginLeft: 8 }}
            >
              Change ordering defaults
            </Link>
          </FlexView>
        )}
      </div>
    </Modal>
  );
}
